export default {
  periodoInscripcion: {},
  periodoInscripciones: [],
  errorArray: [],
  fields: {},
  record: {
    nuevo: false,
    actualizado: false,
  },
  pagination: {},
};
